import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {
    SettingLimit,
    SettingLimitListResponse,
    UserLimitFigure
} from "../http/protocol";


export class BonusSettingLimitService  extends AbstractAdminEntityService<SettingLimit, SettingLimitListResponse>  {

    constructor(http : HttpService) {
        super("/bonus/setting-limits", http)
    }

    getUserFigure(id : number, userId : number) : Promise<UserLimitFigure> {
        return this.http.get(id + "/figure/user/" + userId);
    }

}